import { render, staticRenderFns } from "./GridPosition.vue?vue&type=template&id=38510a14&scoped=true&"
import script from "./GridPosition.vue?vue&type=script&lang=js&"
export * from "./GridPosition.vue?vue&type=script&lang=js&"
import style0 from "./GridPosition.vue?vue&type=style&index=0&id=38510a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38510a14",
  null
  
)

export default component.exports